module.exports = {"350402001":"列东街道","350402002":"列西街道","350402003":"徐碧街道","350402100":"陈大镇","350402101":"洋溪镇","350402500":"福建梅列经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350402.json
// module id = 1186
// module chunks = 0